<template>
  <div></div>
</template>

<script>
import request from "@/utils/request";

export default {
  data() {
    return {
      list: [],
      listQuery: {
        pageInfo: {
          pageSize: 100,
          page: 1,
          totalCount: 0,
        },
        queryStr: "",
        statusInc: [],
      },
    };
  },
  created() {
    // this.getList();
  },
  methods: {
    getList() {
      request.post("/User/Account/Query", this.listQuery).then((res) => {
        console.log(res);
        this.list = res.data.data.data;
      });
    },
  },
};
</script>

<style>
</style>